var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete-with-validation',_vm._g(_vm._b({attrs:{"items":_vm.itemsForSelect,"label":_vm.label},on:{"input":_vm.emitCountryState},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}},'v-autocomplete-with-validation',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }